import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'
import { useHistory } from 'react-router-dom'

const useNotificationsApi = () => {
  const history = useHistory()

  const addToast = useToastContext()
  const [notificationsState, setNotificationsState] = useState({
    communications: {},
    isLoading: false,
    error: null,
  })
  const [notificationsToOpenState, setNotificationsToOpenState] = useState({
    notifications: {},
    isLoading: false,
    error: null,
  })

  async function getNotifications(params) {
    try {
      setNotificationsState((currentNotificationsState) => ({
        ...currentNotificationsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/notifications', {
        params,
        includeToken: true,
      })
      let responseSettings = null
      if (!notificationsState?.serviceTypes) {
        responseSettings = await api.get('/settings', {
          includeToken: true,
          params,
        })
      }

      setNotificationsToOpenState((currentCreateNotificationsToOpenState) => {
        const closedNotifications =
          currentCreateNotificationsToOpenState.notifications.data.filter(
            (notification) =>
              !response.data.data.find((n) => n.id === notification.id)
          )
        return {
          ...currentCreateNotificationsToOpenState,
          notifications: {
            data: closedNotifications,
            count: closedNotifications,
          },
          isLoading: false,
          error: null,
        }
      })

      setNotificationsState((currentNotificationsState) => ({
        notifications: {
          data: response.data.data,
          count: response.data.count,
        },
        serviceTypes: responseSettings
          ? responseSettings?.data?.serviceTypes
          : currentNotificationsState.serviceTypes,
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setNotificationsState({ notifications: null, isLoading: false, error })
    }
  }
  async function getNotificationsToOpen() {
    try {
      setNotificationsToOpenState((currentNotificationsToOpenState) => ({
        ...currentNotificationsToOpenState,
        isLoading: true,
        error: null,
      }))
      const params = { opened: false }
      const response = await api.get('/notifications', {
        params,
        includeToken: true,
      })
      setNotificationsToOpenState((currentCreateNotificationsToOpenState) => ({
        ...currentCreateNotificationsToOpenState,
        notifications: {
          data: response.data.data,
          count: response.data.count,
        },
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setNotificationsToOpenState({
        notifications: null,
        isLoading: false,
        error,
      })
    }
  }

  async function createNotification(payload) {
    try {
      setNotificationsState((currentCreateNotificationsState) => ({
        ...currentCreateNotificationsState,
        isLoading: true,
        error: null,
        success: false,
      }))
      await api.post(`/notifications`, payload)
      setNotificationsState((currentCreateNotificationsState) => ({
        ...currentCreateNotificationsState,
        isLoading: false,
        error: null,
        success: true,
      }))
    } catch (error) {
      setNotificationsState({
        isLoading: false,
        error: error?.response?.data,
        success: false,
      })
    }
  }

  async function updateNotification(id, payload, params) {
    try {
      setNotificationsState((currentCreateNotificationsState) => ({
        ...currentCreateNotificationsState,
        isLoading: true,
        error: null,
        success: false,
      }))
      await api.put(`/notifications/${id}`, payload)
      setNotificationsState((currentCreateNotificationsState) => ({
        ...currentCreateNotificationsState,
        isLoading: false,
        error: null,
        success: true,
      }))
      if (params) {
        await getNotifications(params)
      }
    } catch (error) {
      setNotificationsState({
        isLoading: false,
        error: error?.response?.data,
        success: false,
      })
    }
  }

  async function getServiceTypes(params) {
    try {
      if (notificationsState?.serviceTypes) {
        return
      }
      const response = await api.get('/settings', {
        params,
        includeToken: true,
      })
      setNotificationsState((currentNotificationsState) => ({
        ...currentNotificationsState,
        serviceTypes: response?.data?.serviceTypes,
      }))
    } catch (error) {
      setNotificationsState((currentNotificationsState) => ({
        ...currentNotificationsState,
        error,
      }))
    }
  }

  async function receiveNotification(notification) {
    try {
      setNotificationsState((currentNotificationsState) => {
        const notifications = currentNotificationsState.notifications.data
        notifications.unshift(notification)
        return {
          notifications: {
            data: notifications,
            count: currentNotificationsState.notifications.count + 1,
          },
          serviceTypes: currentNotificationsState.serviceTypes,
          isLoading: false,
          error: null,
        }
      })
    } catch (error) {
      setNotificationsState({
        isLoading: false,
        error: error?.response?.data,
        success: false,
      })
    }
  }

  const state = {
    notificationsState,
    notificationsToOpenState,
  }

  const methods = {
    getNotifications,
    createNotification,
    updateNotification,
    getServiceTypes,
    getNotificationsToOpen,
    receiveNotification,
  }

  return [state, methods]
}

export default useNotificationsApi
